import { useState, useEffect, useContext } from "react";
import { Card, Button, Table, Form, Input, Select, Tabs, message, Modal } from "antd";
import { ReloadOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import listApi from "../../services/api";
import { AuthContext } from "../../context/AuthContext";

const { TabPane } = Tabs;
const { Option } = Select;

const TypeProductManagement = () => {
    const { userData } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [selectedType, setSelectedType] = useState(null);
    const [listShip, setListShip] = useState([]);
    const [loading, setLoading] = useState(false);
    const [typeProduct, setTypeProduct] = useState([]);

    useEffect(() => {
        fetchTypeProduct();
        fetchShips();
    }, []);

    useEffect(() => {
        if (selectedType) {
            form.setFieldsValue({
                name: selectedType.name || "",
                desc: selectedType.desc || "",
                ship_cost: selectedType.ship_cost?.ID?.toString() || undefined,
            });
        } else {
            form.resetFields(); // Reset form khi không có selectedType
        }
    }, [selectedType, listShip, form]);

    const fetchShips = async () => {
        setLoading(true);
        try {
            const response = await fetch(listApi.listShipCost, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ session_id: userData.session_id }),
            });
            const data = await response.json();
            if (data.code === 200) {
                setListShip(data.list_shipcost);
            }
        } catch (error) {
            console.error("Lỗi khi lấy dữ liệu gói ship:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchTypeProduct = async () => {
        setLoading(true);
        try {
            const response = await fetch(listApi.listProductType, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ session_id: userData.session_id }),
            });
            const data = await response.json();
            if (data.code === 200) {
                console.log("Check data",data)
                setTypeProduct(data.list_product_type.map(type => ({
                    id: type.ID,
                    name: type.name,
                    desc: type.desc,
                    ship_cost: type.ship_cost,
                })));
            }
        } catch (error) {
            console.error("Lỗi khi lấy dữ liệu loại sản phẩm:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteType = (typeID) => {
        Modal.confirm({
            title: "Xác nhận xóa",
            content: "Bạn có chắc chắn muốn xóa loại sản phẩm này không?",
            okText: "Xóa",
            okType: "danger",
            cancelText: "Hủy",
            onOk: async () => {
                try {
                    const response = await fetch(listApi.delTypeProduct, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            product_type_id: typeID,
                            session_id: userData.session_id,
                        }),
                    });
                    const result = await response.json();
                    if (result.code === 200) {
                        message.success("Xóa loại sản phẩm thành công!");
                        fetchTypeProduct();
                    } else {
                        message.error(result.desc || "Xóa loại sản phẩm thất bại!");
                    }
                } catch (error) {
                    console.error("Lỗi khi xóa loại sản phẩm:", error);
                    message.error("Đã xảy ra lỗi khi xóa loại sản phẩm.");
                }
            },
        });
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                session_id: userData.session_id,
                product_type_name: values.name,
                desc: values.desc,
                ship_cost: values.ship_cost,
            };
            let url = listApi.createTypeProduct;
            if (selectedType?.id) {
                payload.product_type_id = selectedType.id;
                url = listApi.editTypeProduct;
            }
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            if (result.code === 200) {
                message.success(selectedType ? "Loại sản phẩm đã được cập nhật!" : "Loại sản phẩm đã được tạo!");
                fetchTypeProduct();
                setSelectedType(null);
                form.resetFields();
            } else {
                message.error(`Lỗi: ${result.desc || "Không thể xử lý loại sản phẩm"}`);
            }
        } catch (error) {
            console.error("Lỗi khi xử lý loại sản phẩm:", error);
        }
    };

    const columns = [
        { title: "Tên", dataIndex: "name", key: "name" },
        { title: "Mô tả", dataIndex: "desc", key: "desc", },
        {
            title: "Hành động",
            key: "action",
            render: (_, record) => (
                <>
                    <Button icon={<EditOutlined />} onClick={() => setSelectedType(record)} style={{ marginRight: 8 }}>
                        Sửa
                    </Button>
                    <Button danger icon={<DeleteOutlined />} onClick={() => handleDeleteType(record.id)}>
                        Xóa
                    </Button>
                </>
            ),
        },
    ];

    return (
        <div style={{ padding: "20px" }}>
            <Card
                title="📊 PHÂN LOẠI SẢN PHẨM"
                extra={
                    <>
                        <Button icon={<ReloadOutlined />} onClick={fetchShips} loading={loading} style={{ marginRight: "10px" }}>Tải Lại</Button>
                        <Button
                            onClick={() => {
                                setSelectedType(null);
                                form.resetFields(); // Reset lại form về trạng thái ban đầu
                            }}
                            type="primary"
                            icon={<PlusOutlined />}
                        >
                            Tạo loại sản phẩm mới
                        </Button>
                    </>
                }
                style={{ marginBottom: "20px"}}
            >
                <Table columns={columns} dataSource={typeProduct} pagination={{ pageSize: 10 }} loading={loading} />
            </Card>
            <Card title={selectedType ? "Sửa Loại Sản Phẩm" : "Tạo Loại Sản Phẩm Mới"}>
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                    <Form.Item label="Tên loại sản phẩm:" name="name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item label="Chọn gói ship:" name="ship_cost" rules={[{ required: true }]}>
                        <Select placeholder="Chọn gói ship">
                            {listShip.map(item => (
                                <Select.Option key={item.ID} value={item.ID.toString()}>
                                    {item.name} - {item.cost}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Mô tả:" name="desc" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>

                    <Button type="primary" htmlType="submit">
                        {selectedType ? "Cập Nhật" : "Thêm Loại sản phẩm"}
                    </Button>
                </Form>
            </Card>
        </div>
    );
};
export default TypeProductManagement;